import { CartButton } from "./cart-button";

export const OffresMobileHeader = () => {
  return (
    <div className="xl:hidden">
      <div style={{ display: "block", boxSizing: "border-box" }}>
        <div
          style={{
            boxSizing: "border-box",
            WebkitBoxAlign: "center",
            alignItems: "center",
            backgroundColor: "rgb(12, 19, 31)",
            display: "flex",
            WebkitBoxPack: "justify",
            justifyContent: "space-between",
            padding: "12px 16px",
            position: "relative",
            zIndex: 1202,
          }}
        >
          <a
            aria-label="Retour à l'accueil SNCF Connect"
            href="/"
            style={{
              boxSizing: "border-box",
              backgroundColor: "rgba(0, 0, 0, 0)",
              margin: "0px",
              fontSize: "13px",
              lineHeight: "18px",
              fontWeight: 700,
              color: "rgb(141, 232, 254)",
              textDecoration: "none solid rgb(141, 232, 254)",
              cursor: "pointer",
              position: "relative",
              display: "flex",
              WebkitBoxAlign: "center",
              alignItems: "center",
              WebkitBoxPack: "center",
              justifyContent: "center",
              height: "48px",
            }}
          >
            <svg
              aria-hidden="true"
              viewBox="0 0 130 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ boxSizing: "border-box", height: "48px" }}
            >
              <path
                d="M33.593 11.955H10.276C4.594 11.955 0 16.575 0 22.255a10.268 10.268 0 0 0 10.276 10.276h23.317A10.268 10.268 0 0 0 43.87 22.256c0-5.682-4.595-10.3-10.276-10.3ZM4.57 42.288c-.89 0-1.804.321-1.804 1.21 0 .865.865 1.063 2.421 1.433 1.655.395 3.607 1.136 3.607 3.36 0 2.717-2.224 3.73-4.669 3.73-1.235 0-2.643-.347-3.507-1.014-.494-.37-.618-.79-.618-1.111 0-.642.494-1.186 1.16-1.186.297 0 .594.1.964.37.643.52 1.359.791 2.15.791.814 0 1.827-.32 1.827-1.334 0-.938-.89-1.185-2.593-1.58-1.655-.396-3.31-1.063-3.31-3.187 0-2.495 2.223-3.557 4.446-3.557 1.111 0 2.297.272 3.087.865.544.395.667.765.667 1.087 0 .617-.444 1.136-1.136 1.136-.247 0-.519-.099-.815-.321-.593-.494-1.21-.692-1.877-.692Zm6.644-.519c0-1.26.914-1.457 1.334-1.457.42 0 1.334.198 1.334 1.457v.544h.05c.493-1.112 1.827-2.125 3.457-2.125 2.915 0 4.126 2.224 4.126 4.52v5.633c0 1.333-.94 1.556-1.409 1.556-.469 0-1.407-.223-1.407-1.556v-4.842c0-1.334-.297-2.989-2.1-2.989-1.779 0-2.618 1.532-2.618 3.039v4.792c0 1.333-.939 1.556-1.408 1.556-.47 0-1.408-.223-1.408-1.556v-8.572h.05Zm21.44 7.09c.717 0 1.137.543 1.137 1.111 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.989.815-3.335 0-5.953-2.198-5.953-5.903 0-3.631 2.692-5.904 5.978-5.904 1.062 0 2.149.247 2.94.79.641.445.79.89.79 1.211 0 .617-.47 1.21-1.21 1.21-.248 0-.52-.074-.94-.37a2.678 2.678 0 0 0-1.58-.519c-2.05 0-3.063 1.828-3.063 3.582 0 1.754.988 3.557 3.063 3.557.617 0 1.16-.149 1.655-.47.37-.247.667-.346.914-.346Zm4.1-6.102c-1.061 0-1.259-.74-1.259-1.111 0-.37.198-1.112 1.26-1.112h1.062V38.88c0-2.667 1.038-5.063 4.273-5.063 1.161 0 1.779.395 1.779 1.235 0 .617-.42 1.136-1.31 1.136-1.506 0-1.95.963-1.95 2.52v1.827h1.53c1.063 0 1.26.741 1.26 1.112 0 .37-.197 1.111-1.26 1.111h-1.53v7.584c0 1.333-.94 1.556-1.409 1.556-.444 0-1.408-.223-1.408-1.556v-7.584h-1.037Z"
                fill="#8DE8FE"
                style={{ boxSizing: "border-box" }}
              ></path>
              <path
                d="M56.121 11.955a10.268 10.268 0 0 0-10.275 10.276A10.268 10.268 0 0 0 56.12 32.507 10.268 10.268 0 0 0 66.397 22.23 10.268 10.268 0 0 0 56.12 11.955ZM54.392 48.858c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.99.815-3.334 0-5.977-2.198-5.977-5.928 0-3.631 2.717-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.79.89.79 1.21 0 .618-.469 1.21-1.21 1.21-.247 0-.519-.073-.938-.37a2.678 2.678 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.16-.148 1.655-.47.37-.172.666-.296.913-.296Zm8.768 3.187c-3.384 0-6.076-2.446-6.076-5.978 0-3.532 2.717-5.879 6.076-5.879 3.384 0 6.077 2.347 6.077 5.879 0 3.508-2.693 5.978-6.077 5.978Zm0-9.584c-2.223 0-3.235 1.852-3.235 3.581 0 1.754 1.037 3.631 3.235 3.631 2.223 0 3.236-1.877 3.236-3.63 0-1.73-1.037-3.582-3.236-3.582Zm8.473-.692c0-1.26.914-1.482 1.334-1.482.42 0 1.333.198 1.333 1.482v.544h.05c.494-1.112 1.828-2.125 3.483-2.125 2.914 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.297-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-8.62h.025Zm13.091 0c0-1.26.914-1.482 1.334-1.482.42 0 1.334.198 1.334 1.482v.544h.05c.493-1.112 1.827-2.125 3.482-2.125 2.915 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.296-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.938 1.556-1.407 1.556-.47 0-1.409-.222-1.409-1.556v-8.62h.025Zm15.414 5.237c.123 1.58 1.556 2.742 3.186 2.742 1.161 0 1.877-.371 2.569-.964.395-.321.642-.395.963-.395.618 0 1.112.444 1.112 1.111 0 .223-.099.643-.47 1.013-1.086 1.038-2.346 1.507-4.149 1.507-3.459 0-6.027-2.223-6.027-5.854 0-3.606 2.544-6.002 5.928-6.002 2.717 0 4.891 1.531 5.335 4.816.025.223.05.395.05.593 0 .988-.544 1.408-1.458 1.408h-7.039v.025Zm5.73-2.026c0-1.457-.815-2.717-2.643-2.717-1.655 0-2.989 1.136-3.112 2.717h5.755Zm13.092 3.878c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.791.568-2.026.815-2.989.815-3.335 0-5.978-2.198-5.978-5.928 0-3.631 2.718-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.791.89.791 1.21 0 .618-.47 1.21-1.211 1.21-.247 0-.518-.073-.938-.37a2.68 2.68 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.161-.148 1.655-.47.37-.172.667-.296.914-.296Zm8.25 3.088c-2.964 0-3.607-1.828-3.607-3.977v-5.237h-.914c-1.062 0-1.259-.74-1.259-1.111 0-.37.197-1.112 1.259-1.112h.914v-1.926c0-1.285.914-1.507 1.384-1.507.469 0 1.383.222 1.383 1.507v1.926h1.754c1.062 0 1.259.741 1.259 1.112 0 .37-.197 1.111-1.259 1.111h-1.754v5.212c0 1.087.37 1.68 1.062 1.68.124 0 .272-.025.445-.05.197-.024.222-.024.321-.024.691 0 1.062.519 1.062 1.037 0 .445-.247.815-.667 1.038a3.085 3.085 0 0 1-1.383.32Z"
                fill="#fff"
                style={{ boxSizing: "border-box" }}
              ></path>
              <path
                d="M39.868 25.592a7.484 7.484 0 1 0-13.388-6.694 7.484 7.484 0 0 0 13.388 6.694Z"
                fill="#0C131F"
                style={{ boxSizing: "border-box" }}
              ></path>
            </svg>
          </a>
          <CartButton />
        </div>
      </div>
      <header
        role="banner"
        tabIndex={-1}
        style={{ boxSizing: "border-box", color: "rgb(243, 243, 244)" }}
      >
        <div style={{ display: "block", boxSizing: "border-box" }}>
          <nav
            role="navigation"
            aria-label="Menu principal"
            data-test="tabBar-header"
            style={{
              zIndex: 1202,
              boxSizing: "border-box",
              backgroundColor: "rgb(12, 19, 31)",
              bottom: "0px",
              height: "58px",
              left: "0px",
              position: "fixed",
              right: "0px",
            }}
          >
            <ul
              style={{
                boxSizing: "border-box",
                listStyle: "outside none none",
                margin: "0px",
                padding: "0px",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(2rem, 1fr))",
                WebkitBoxPack: "center",
                justifyContent: "center",
                height: "58px",
                width: "100%",
              }}
            >
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Voyager"
                  aria-controls="tabBar-panelContent-0"
                  aria-expanded="false"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(243, 243, 244)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(243, 243, 244)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path
                        d="M19 15C18.2925 15.0019 17.6083 15.2538 17.0685 15.7113C16.5287 16.1688 16.168 16.8023 16.05 17.5H7.65003C6.84156 17.5297 6.0431 17.3135 5.36003 16.88C5.09371 16.6953 4.87628 16.4485 4.72647 16.1611C4.57665 15.8737 4.49895 15.5541 4.50003 15.23C4.4716 14.8369 4.53649 14.4427 4.68943 14.0795C4.84236 13.7163 5.079 13.3944 5.38003 13.14C6.04631 12.6841 6.84373 12.4593 7.65003 12.5H16C16.8515 12.4777 17.6728 12.1794 18.34 11.65C18.7372 11.2878 19.0477 10.8409 19.2485 10.3423C19.4493 9.84373 19.5353 9.30634 19.5 8.77001C19.5114 8.2984 19.4113 7.83077 19.208 7.40508C19.0048 6.97938 18.7039 6.60763 18.33 6.32001C17.55 5.76186 16.6089 5.47392 15.65 5.50001H8.00003C7.87466 4.75831 7.47523 4.09077 6.8809 3.62968C6.28656 3.1686 5.5407 2.94761 4.79111 3.01051C4.04153 3.07342 3.34293 3.41563 2.83375 3.96932C2.32458 4.52301 2.04199 5.24779 2.04199 6.00001C2.04199 6.75223 2.32458 7.477 2.83375 8.03069C3.34293 8.58438 4.04153 8.92659 4.79111 8.9895C5.5407 9.0524 6.28656 8.83142 6.8809 8.37033C7.47523 7.90924 7.87466 7.2417 8.00003 6.50001H15.7C16.4353 6.4694 17.16 6.68398 17.76 7.11001C18.0149 7.30336 18.2196 7.55501 18.3571 7.84386C18.4945 8.1327 18.5607 8.4503 18.55 8.77001C18.5817 9.15843 18.5253 9.54899 18.3851 9.91259C18.2448 10.2762 18.0243 10.6035 17.74 10.87C17.1688 11.3098 16.4602 11.533 15.74 11.5H7.74003C6.70744 11.4538 5.68938 11.7568 4.85003 12.36C4.41249 12.6961 4.06166 13.132 3.82681 13.6312C3.59197 14.1305 3.47993 14.6786 3.50003 15.23C3.49277 15.714 3.60594 16.1922 3.82937 16.6216C4.05281 17.0511 4.37949 17.4182 4.78003 17.69C5.63042 18.2492 6.63277 18.5321 7.65003 18.5H16.05C16.1454 19.0643 16.4002 19.5896 16.7844 20.0138C17.1686 20.438 17.6661 20.7435 18.2182 20.8941C18.7703 21.0448 19.354 21.0344 19.9004 20.8642C20.4468 20.694 20.9331 20.371 21.302 19.9334C21.6708 19.4958 21.9068 18.9618 21.982 18.3945C22.0573 17.8272 21.9687 17.2501 21.7267 16.7315C21.4847 16.2129 21.0994 15.7743 20.6163 15.4675C20.1331 15.1607 19.5723 14.9985 19 15ZM19 20C18.6045 20 18.2178 19.8827 17.8889 19.6629C17.56 19.4432 17.3036 19.1308 17.1523 18.7654C17.0009 18.3999 16.9613 17.9978 17.0385 17.6098C17.1156 17.2219 17.3061 16.8655 17.5858 16.5858C17.8655 16.3061 18.2219 16.1156 18.6099 16.0384C18.9978 15.9613 19.3999 16.0009 19.7654 16.1522C20.1309 16.3036 20.4432 16.56 20.663 16.8889C20.8827 17.2178 21 17.6044 21 18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0392 19.7893 19.5305 20 19 20Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Voyager
                      </span>
                    </span>
                  </div>
                </button>
              </li>
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Billets"
                  aria-controls="tabBar-panelContent-1"
                  aria-expanded="false"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(243, 243, 244)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(243, 243, 244)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path
                        d="M18 6H16V8H18V6Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M13 3V11H21V3H13ZM20 10H14V4H20V10Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M8 16H6V18H8V16Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M3 21H11V13H3V21ZM4 14H10V20H4V14Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M18 16H16V18H18V16Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M5 9H3V11H5V9Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M11 3H9V5H11V3Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M8 6H6V8H8V6Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M5 3H3V5H5V3Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M11 9H9V11H11V9Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M15 13H13V15H15V13Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M21 13H19V15H21V13Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M15 19H13V21H15V19Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Billets
                      </span>
                    </span>
                  </div>
                </button>
              </li>
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Offres"
                  aria-controls="tabBar-panelContent-2"
                  aria-expanded="false"
                  aria-current="true"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(141, 232, 254) none 0px",
                    border: "0px none rgb(141, 232, 254)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(141, 232, 254)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(141, 232, 254)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(141, 232, 254)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path
                        d="M20 2.99995H19.13V9.86376C19.1298 9.92559 19.109 9.98559 19.071 10.0344C19.033 10.0832 18.9799 10.1181 18.92 10.1335C18.8601 10.1551 18.7948 10.157 18.7337 10.1391C18.6725 10.1211 18.6187 10.0842 18.58 10.0336L16.93 7.90552L16.72 7.80561H16.47L16.37 7.85557L14.63 9.99364C14.5903 10.043 14.5365 10.0791 14.4757 10.0969C14.4149 10.1148 14.3501 10.1136 14.29 10.0935C14.2301 10.0781 14.177 10.0432 14.139 9.99443C14.101 9.94563 14.0802 9.88562 14.08 9.82379V3.16979L13.3 3.67934C12.7551 4.04506 12.3086 4.53916 12 5.11804C11.6544 4.46934 11.1364 3.92841 10.503 3.55473C9.86969 3.18105 9.14547 2.98909 8.41 2.99995H4C3.4798 2.99971 2.97998 3.20199 2.60658 3.56386C2.23319 3.92572 2.01561 4.4187 2 4.9382L2 16.9873C2.01815 17.5051 2.23685 17.9955 2.60997 18.3553C2.98309 18.715 3.48148 18.9159 4 18.9156H7.6C8.45713 18.9091 9.29534 19.1673 10 19.6549L10.64 20.1045L11.26 20.704C11.353 20.7976 11.4636 20.872 11.5854 20.9227C11.7073 20.9734 11.838 20.9995 11.97 20.9995C12.102 20.9995 12.2327 20.9734 12.3546 20.9227C12.4764 20.872 12.587 20.7976 12.68 20.704L13.27 20.1345L13.94 19.6549C14.6455 19.1492 15.4917 18.8767 16.36 18.8756H20C20.5119 18.8764 21.0046 18.681 21.3767 18.3297C21.7488 17.9785 21.9718 17.498 22 16.9873V4.99815C22 4.46819 21.7893 3.95994 21.4142 3.58521C21.0391 3.21047 20.5304 2.99995 20 2.99995ZM6.22 14.1199C6.12343 14.2593 5.98774 14.3671 5.83 14.4296C5.67031 14.4885 5.49821 14.5057 5.33 14.4796C5.16278 14.4428 5.00783 14.3636 4.88 14.2498C4.75317 14.1341 4.66869 13.9794 4.64 13.8102C4.5851 13.655 4.5851 13.4858 4.64 13.3306C4.72046 13.1818 4.84666 13.0627 5 12.9909C5.14667 12.8986 5.31667 12.8501 5.49 12.8511C5.719 12.8529 5.93947 12.9381 6.11 13.0908C6.26862 13.2503 6.35837 13.4655 6.36 13.6903C6.35566 13.844 6.30705 13.9931 6.22 14.1199ZM9.54 14.2098C9.39133 14.3634 9.19281 14.459 8.98 14.4796H8.11C7.99128 14.5044 7.86872 14.5044 7.75 14.4796C7.63529 14.4418 7.52972 14.3806 7.44 14.2998C7.34092 14.2174 7.26509 14.1107 7.22 13.99C7.16708 13.8828 7.13955 13.7649 7.13955 13.6453C7.13955 13.5258 7.16708 13.4079 7.22 13.3007C7.26509 13.18 7.34092 13.0733 7.44 12.9909C7.52972 12.9101 7.63529 12.8489 7.75 12.8111C7.86872 12.7863 7.99128 12.7863 8.11 12.8111H9C9.21281 12.8317 9.41133 12.9273 9.56 13.0809C9.70054 13.2353 9.77841 13.4366 9.77841 13.6453C9.77841 13.8541 9.70054 14.0554 9.56 14.2098H9.54ZM9.54 10.8728C9.39646 11.0222 9.20572 11.1175 9 11.1426H5.5C5.2867 11.1238 5.0876 11.0278 4.94 10.8728C4.79278 10.7218 4.71041 10.5192 4.71041 10.3084C4.71041 10.0975 4.79278 9.89496 4.94 9.74387C5.0876 9.58887 5.2867 9.49296 5.5 9.47411H9C9.21281 9.49471 9.41133 9.59034 9.56 9.74387C9.70054 9.89834 9.77841 10.0996 9.77841 10.3084C9.77841 10.5171 9.70054 10.7184 9.56 10.8728H9.54ZM9.54 7.52587C9.39646 7.67522 9.20572 7.7705 9 7.79562H5.5C5.2867 7.77677 5.0876 7.68086 4.94 7.52587C4.80234 7.38257 4.72072 7.19467 4.71 6.99634C4.70964 6.89256 4.72976 6.78972 4.76923 6.69371C4.8087 6.5977 4.86673 6.51042 4.94 6.43685C5.08659 6.27891 5.28558 6.17951 5.5 6.1571H9C9.21391 6.18124 9.41233 6.28036 9.56 6.43685C9.69439 6.59178 9.76575 6.79141 9.76 6.99634C9.74872 7.19263 9.67116 7.3793 9.54 7.52587ZM19.16 14.2098C19.0098 14.3613 18.8121 14.4565 18.6 14.4796H15.11C14.9002 14.4584 14.7051 14.3627 14.56 14.2098C14.4128 14.0587 14.3304 13.8562 14.3304 13.6453C14.3304 13.4345 14.4128 13.2319 14.56 13.0809C14.7051 12.928 14.9002 12.8323 15.11 12.8111H18.6C18.8121 12.8342 19.0098 12.9294 19.16 13.0809C19.3005 13.2353 19.3784 13.4366 19.3784 13.6453C19.3784 13.8541 19.3005 14.0554 19.16 14.2098Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        WebkitBoxPack: "center",
                        justifyContent: "center",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Offres
                      </span>
                    </span>
                  </div>
                </button>
              </li>
              <li style={{ boxSizing: "border-box" }}>
                <button
                  tabIndex={0}
                  type="button"
                  aria-label="Menu Compte"
                  aria-controls="tabBar-panelContent-3"
                  aria-expanded="false"
                  style={{
                    boxSizing: "border-box",
                    appearance: "button",
                    textTransform: "none",
                    overflow: "visible",
                    fontFamily: "Avenir",
                    fontSize: "14px",
                    lineHeight: "24.5px",
                    margin: "0px",
                    display: "inline-flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    position: "relative",
                    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    outline: "rgb(243, 243, 244) none 0px",
                    border: "0px none rgb(243, 243, 244)",
                    cursor: "pointer",
                    userSelect: "none",
                    verticalAlign: "middle",
                    textDecoration: "none solid rgb(243, 243, 244)",
                    fontWeight: 700,
                    minWidth: "64px",
                    borderRadius: "14px",
                    transition:
                      "background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, box-shadow 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, border-color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s, color 0.25s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                    color: "rgb(243, 243, 244)",
                    padding: "0px",
                    height: "58px",
                    width: "100%",
                    whiteSpace: "pre",
                  }}
                >
                  <div
                    style={{
                      boxSizing: "border-box",
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                      height: "58px",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        boxSizing: "border-box",
                        height: "24px",
                        width: "1.5rem",
                        fill: "rgb(243, 243, 244)",
                        flexShrink: 0,
                        margin: "8px 0px 4px",
                      }}
                    >
                      <path
                        d="M14.2507 10.0988C14.9317 9.65003 15.4628 9.00399 15.7743 8.24522C16.0859 7.48646 16.1634 6.65033 15.9968 5.84629C15.8476 5.03646 15.4591 4.29126 14.8826 3.70878C14.3061 3.12629 13.5686 2.73381 12.7671 2.58299C11.9711 2.41824 11.1444 2.49999 10.3952 2.81754C9.86342 3.0379 9.38334 3.36855 8.98599 3.78813C8.58863 4.2077 8.28284 4.70685 8.08837 5.25332C7.89391 5.79978 7.81511 6.3814 7.85706 6.96056C7.89901 7.53973 8.06078 8.10355 8.33191 8.61559C8.60304 9.12763 8.9775 9.57648 9.43109 9.93313C9.88467 10.2898 10.4073 10.5463 10.9651 10.6861C11.523 10.8259 12.1036 10.8458 12.6696 10.7447C13.2356 10.6435 13.7742 10.4235 14.2507 10.0988ZM13.6956 4.05147C14.2053 4.39619 14.6022 4.88597 14.8361 5.45877C15.1178 6.15045 15.1443 6.92136 14.9107 7.63109C14.6771 8.34082 14.1989 8.94216 13.5633 9.32559C12.9277 9.70903 12.177 9.84904 11.4478 9.72014C10.7186 9.59123 10.0594 9.20198 9.59045 8.62329C9.12146 8.04459 8.87378 7.31494 8.89254 6.56722C8.9113 5.81951 9.19524 5.10347 9.69264 4.54953C10.1901 3.99558 10.8678 3.64057 11.6026 3.54915C12.3373 3.45774 13.0801 3.636 13.6956 4.05147Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                      <path
                        d="M7.39753 15.1161C8.30094 14.1869 9.45816 13.551 10.7212 13.2899C11.9842 13.0287 13.2956 13.1542 14.4877 13.6502C15.6798 14.1462 16.6983 14.9902 17.413 16.0743C18.1278 17.1583 18.5062 18.4332 18.4999 19.7357V20.9901C18.4973 21.1245 18.4433 21.2527 18.3493 21.3477C18.2552 21.4428 18.1283 21.4974 17.9953 21.5C17.8622 21.4974 17.7354 21.4428 17.6413 21.3477C17.5472 21.2527 17.4932 21.1245 17.4906 20.9901V19.7357C17.4906 18.2644 16.9121 16.8534 15.8824 15.813C14.8528 14.7726 13.4562 14.1881 12 14.1881C10.5438 14.1881 9.14721 14.7726 8.11751 15.813C7.08782 16.8534 6.50934 18.2644 6.50934 19.7357V20.9901C6.50676 21.1245 6.45276 21.2527 6.35867 21.3477C6.26459 21.4428 6.13772 21.4974 6.00469 21.5C5.9385 21.5008 5.87288 21.4876 5.81204 21.4612C5.7512 21.4349 5.69649 21.396 5.65143 21.347C5.60295 21.3015 5.56443 21.2462 5.53836 21.1847C5.51228 21.1233 5.49923 21.0569 5.50004 20.9901V19.7357C5.5014 18.0026 6.18392 16.341 7.39753 15.1161Z"
                        style={{ boxSizing: "border-box" }}
                      ></path>
                    </svg>
                    <span
                      style={{
                        boxSizing: "border-box",
                        display: "flex",
                        height: "22px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          boxSizing: "border-box",
                          margin: "0px",
                          maxWidth: "96px",
                          fontSize: "11px",
                          lineHeight: "14px",
                          fontWeight: 700,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        Compte
                      </span>
                    </span>
                  </div>
                </button>
              </li>
            </ul>
            <div
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgb(141, 232, 254)",
                borderTopLeftRadius: "48px",
                borderTopRightRadius: "48px",
                bottom: "0px",
                content: '""',
                height: "2px",
                position: "absolute",
                width: "100%",
                left: "0px",
                opacity: 0,
                pointerEvents: "none",
              }}
            ></div>
          </nav>
        </div>
        <div style={{ display: "none", boxSizing: "border-box" }}>
          <div
            style={{
              boxSizing: "border-box",
              backgroundColor: "rgb(12, 19, 31)",
              height: "64px",
              minWidth: "100%",
              position: "absolute",
              zIndex: 1201,
            }}
          ></div>
          <div
            data-test="navBar-header"
            style={{
              zIndex: 1202,
              boxSizing: "border-box",
              backgroundColor: "rgb(12, 19, 31)",
              bottom: "0px",
              height: "58px",
              left: "0px",
              position: "fixed",
              right: "0px",
            }}
          >
            <div
              style={{
                boxSizing: "border-box",
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                display: "block",
                paddingLeft: "16px",
                paddingRight: "16px",
              }}
            >
              <div
                style={{
                  boxSizing: "border-box",
                  display: "grid",
                  gridTemplateColumns: "1fr auto 1fr",
                  height: "100%",
                }}
              >
                <a
                  aria-label="Retour à l'accueil SNCF Connect"
                  href="/app"
                  style={{
                    boxSizing: "border-box",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                    margin: "0px",
                    fontSize: "13px",
                    lineHeight: "18px",
                    fontWeight: 700,
                    color: "rgb(141, 232, 254)",
                    textDecoration: "none solid rgb(141, 232, 254)",
                    cursor: "pointer",
                    position: "relative",
                    display: "flex",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    WebkitBoxPack: "center",
                    justifyContent: "center",
                    width: "fit-content",
                  }}
                >
                  <svg
                    aria-hidden="true"
                    viewBox="0 0 130 64"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ boxSizing: "border-box", height: "48px" }}
                  >
                    <path
                      d="M33.593 11.955H10.276C4.594 11.955 0 16.575 0 22.255a10.268 10.268 0 0 0 10.276 10.276h23.317A10.268 10.268 0 0 0 43.87 22.256c0-5.682-4.595-10.3-10.276-10.3ZM4.57 42.288c-.89 0-1.804.321-1.804 1.21 0 .865.865 1.063 2.421 1.433 1.655.395 3.607 1.136 3.607 3.36 0 2.717-2.224 3.73-4.669 3.73-1.235 0-2.643-.347-3.507-1.014-.494-.37-.618-.79-.618-1.111 0-.642.494-1.186 1.16-1.186.297 0 .594.1.964.37.643.52 1.359.791 2.15.791.814 0 1.827-.32 1.827-1.334 0-.938-.89-1.185-2.593-1.58-1.655-.396-3.31-1.063-3.31-3.187 0-2.495 2.223-3.557 4.446-3.557 1.111 0 2.297.272 3.087.865.544.395.667.765.667 1.087 0 .617-.444 1.136-1.136 1.136-.247 0-.519-.099-.815-.321-.593-.494-1.21-.692-1.877-.692Zm6.644-.519c0-1.26.914-1.457 1.334-1.457.42 0 1.334.198 1.334 1.457v.544h.05c.493-1.112 1.827-2.125 3.457-2.125 2.915 0 4.126 2.224 4.126 4.52v5.633c0 1.333-.94 1.556-1.409 1.556-.469 0-1.407-.223-1.407-1.556v-4.842c0-1.334-.297-2.989-2.1-2.989-1.779 0-2.618 1.532-2.618 3.039v4.792c0 1.333-.939 1.556-1.408 1.556-.47 0-1.408-.223-1.408-1.556v-8.572h.05Zm21.44 7.09c.717 0 1.137.543 1.137 1.111 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.989.815-3.335 0-5.953-2.198-5.953-5.903 0-3.631 2.692-5.904 5.978-5.904 1.062 0 2.149.247 2.94.79.641.445.79.89.79 1.211 0 .617-.47 1.21-1.21 1.21-.248 0-.52-.074-.94-.37a2.678 2.678 0 0 0-1.58-.519c-2.05 0-3.063 1.828-3.063 3.582 0 1.754.988 3.557 3.063 3.557.617 0 1.16-.149 1.655-.47.37-.247.667-.346.914-.346Zm4.1-6.102c-1.061 0-1.259-.74-1.259-1.111 0-.37.198-1.112 1.26-1.112h1.062V38.88c0-2.667 1.038-5.063 4.273-5.063 1.161 0 1.779.395 1.779 1.235 0 .617-.42 1.136-1.31 1.136-1.506 0-1.95.963-1.95 2.52v1.827h1.53c1.063 0 1.26.741 1.26 1.112 0 .37-.197 1.111-1.26 1.111h-1.53v7.584c0 1.333-.94 1.556-1.409 1.556-.444 0-1.408-.223-1.408-1.556v-7.584h-1.037Z"
                      fill="#8DE8FE"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                    <path
                      d="M56.121 11.955a10.268 10.268 0 0 0-10.275 10.276A10.268 10.268 0 0 0 56.12 32.507 10.268 10.268 0 0 0 66.397 22.23 10.268 10.268 0 0 0 56.12 11.955ZM54.392 48.858c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.79.568-2.026.815-2.99.815-3.334 0-5.977-2.198-5.977-5.928 0-3.631 2.717-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.79.89.79 1.21 0 .618-.469 1.21-1.21 1.21-.247 0-.519-.073-.938-.37a2.678 2.678 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.16-.148 1.655-.47.37-.172.666-.296.913-.296Zm8.768 3.187c-3.384 0-6.076-2.446-6.076-5.978 0-3.532 2.717-5.879 6.076-5.879 3.384 0 6.077 2.347 6.077 5.879 0 3.508-2.693 5.978-6.077 5.978Zm0-9.584c-2.223 0-3.235 1.852-3.235 3.581 0 1.754 1.037 3.631 3.235 3.631 2.223 0 3.236-1.877 3.236-3.63 0-1.73-1.037-3.582-3.236-3.582Zm8.473-.692c0-1.26.914-1.482 1.334-1.482.42 0 1.333.198 1.333 1.482v.544h.05c.494-1.112 1.828-2.125 3.483-2.125 2.914 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.297-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-8.62h.025Zm13.091 0c0-1.26.914-1.482 1.334-1.482.42 0 1.334.198 1.334 1.482v.544h.05c.493-1.112 1.827-2.125 3.482-2.125 2.915 0 4.125 2.248 4.125 4.52v5.657c0 1.334-.939 1.556-1.408 1.556-.47 0-1.408-.222-1.408-1.556v-4.841c0-1.334-.296-2.99-2.1-2.99-1.778 0-2.618 1.532-2.618 3.039v4.817c0 1.334-.938 1.556-1.407 1.556-.47 0-1.409-.222-1.409-1.556v-8.62h.025Zm15.414 5.237c.123 1.58 1.556 2.742 3.186 2.742 1.161 0 1.877-.371 2.569-.964.395-.321.642-.395.963-.395.618 0 1.112.444 1.112 1.111 0 .223-.099.643-.47 1.013-1.086 1.038-2.346 1.507-4.149 1.507-3.459 0-6.027-2.223-6.027-5.854 0-3.606 2.544-6.002 5.928-6.002 2.717 0 4.891 1.531 5.335 4.816.025.223.05.395.05.593 0 .988-.544 1.408-1.458 1.408h-7.039v.025Zm5.73-2.026c0-1.457-.815-2.717-2.643-2.717-1.655 0-2.989 1.136-3.112 2.717h5.755Zm13.092 3.878c.716 0 1.136.544 1.136 1.112 0 .395-.124.79-.741 1.235-.791.568-2.026.815-2.989.815-3.335 0-5.978-2.198-5.978-5.928 0-3.631 2.718-5.928 6.003-5.928 1.062 0 2.149.246 2.939.79.642.445.791.89.791 1.21 0 .618-.47 1.21-1.211 1.21-.247 0-.518-.073-.938-.37a2.68 2.68 0 0 0-1.581-.519c-2.05 0-3.088 1.853-3.088 3.582 0 1.754.988 3.557 3.088 3.557.617 0 1.161-.148 1.655-.47.37-.172.667-.296.914-.296Zm8.25 3.088c-2.964 0-3.607-1.828-3.607-3.977v-5.237h-.914c-1.062 0-1.259-.74-1.259-1.111 0-.37.197-1.112 1.259-1.112h.914v-1.926c0-1.285.914-1.507 1.384-1.507.469 0 1.383.222 1.383 1.507v1.926h1.754c1.062 0 1.259.741 1.259 1.112 0 .37-.197 1.111-1.259 1.111h-1.754v5.212c0 1.087.37 1.68 1.062 1.68.124 0 .272-.025.445-.05.197-.024.222-.024.321-.024.691 0 1.062.519 1.062 1.037 0 .445-.247.815-.667 1.038a3.085 3.085 0 0 1-1.383.32Z"
                      fill="#fff"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                    <path
                      d="M39.868 25.592a7.484 7.484 0 1 0-13.388-6.694 7.484 7.484 0 0 0 13.388 6.694Z"
                      fill="#0C131F"
                      style={{ boxSizing: "border-box" }}
                    ></path>
                  </svg>
                </a>
                <nav
                  aria-label="Menu principal"
                  style={{ boxSizing: "border-box" }}
                >
                  <ul
                    style={{
                      boxSizing: "border-box",
                      listStyle: "outside none none",
                      margin: "0px",
                      padding: "0px",
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(2rem, 1fr))",
                      WebkitBoxPack: "center",
                      justifyContent: "center",
                      height: "100%",
                      width: "100%",
                    }}
                  >
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Voyager"
                          href="/"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(243, 243, 244)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(243, 243, 244)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(243, 243, 244)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M19 15C18.2925 15.0019 17.6083 15.2538 17.0685 15.7113C16.5287 16.1688 16.168 16.8023 16.05 17.5H7.65003C6.84156 17.5297 6.0431 17.3135 5.36003 16.88C5.09371 16.6953 4.87628 16.4485 4.72647 16.1611C4.57665 15.8737 4.49895 15.5541 4.50003 15.23C4.4716 14.8369 4.53649 14.4427 4.68943 14.0795C4.84236 13.7163 5.079 13.3944 5.38003 13.14C6.04631 12.6841 6.84373 12.4593 7.65003 12.5H16C16.8515 12.4777 17.6728 12.1794 18.34 11.65C18.7372 11.2878 19.0477 10.8409 19.2485 10.3423C19.4493 9.84373 19.5353 9.30634 19.5 8.77001C19.5114 8.2984 19.4113 7.83077 19.208 7.40508C19.0048 6.97938 18.7039 6.60763 18.33 6.32001C17.55 5.76186 16.6089 5.47392 15.65 5.50001H8.00003C7.87466 4.75831 7.47523 4.09077 6.8809 3.62968C6.28656 3.1686 5.5407 2.94761 4.79111 3.01051C4.04153 3.07342 3.34293 3.41563 2.83375 3.96932C2.32458 4.52301 2.04199 5.24779 2.04199 6.00001C2.04199 6.75223 2.32458 7.477 2.83375 8.03069C3.34293 8.58438 4.04153 8.92659 4.79111 8.9895C5.5407 9.0524 6.28656 8.83142 6.8809 8.37033C7.47523 7.90924 7.87466 7.2417 8.00003 6.50001H15.7C16.4353 6.4694 17.16 6.68398 17.76 7.11001C18.0149 7.30336 18.2196 7.55501 18.3571 7.84386C18.4945 8.1327 18.5607 8.4503 18.55 8.77001C18.5817 9.15843 18.5253 9.54899 18.3851 9.91259C18.2448 10.2762 18.0243 10.6035 17.74 10.87C17.1688 11.3098 16.4602 11.533 15.74 11.5H7.74003C6.70744 11.4538 5.68938 11.7568 4.85003 12.36C4.41249 12.6961 4.06166 13.132 3.82681 13.6312C3.59197 14.1305 3.47993 14.6786 3.50003 15.23C3.49277 15.714 3.60594 16.1922 3.82937 16.6216C4.05281 17.0511 4.37949 17.4182 4.78003 17.69C5.63042 18.2492 6.63277 18.5321 7.65003 18.5H16.05C16.1454 19.0643 16.4002 19.5896 16.7844 20.0138C17.1686 20.438 17.6661 20.7435 18.2182 20.8941C18.7703 21.0448 19.354 21.0344 19.9004 20.8642C20.4468 20.694 20.9331 20.371 21.302 19.9334C21.6708 19.4958 21.9068 18.9618 21.982 18.3945C22.0573 17.8272 21.9687 17.2501 21.7267 16.7315C21.4847 16.2129 21.0994 15.7743 20.6163 15.4675C20.1331 15.1607 19.5723 14.9985 19 15ZM19 20C18.6045 20 18.2178 19.8827 17.8889 19.6629C17.56 19.4432 17.3036 19.1308 17.1523 18.7654C17.0009 18.3999 16.9613 17.9978 17.0385 17.6098C17.1156 17.2219 17.3061 16.8655 17.5858 16.5858C17.8655 16.3061 18.2219 16.1156 18.6099 16.0384C18.9978 15.9613 19.3999 16.0009 19.7654 16.1522C20.1309 16.3036 20.4432 16.56 20.663 16.8889C20.8827 17.2178 21 17.6044 21 18C21 18.5304 20.7893 19.0391 20.4142 19.4142C20.0392 19.7893 19.5305 20 19 20Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Voyager
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-0"
                          aria-expanded="false"
                          aria-label="Menu Voyager"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily:
                              "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Billets"
                          href="/app/trips"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(243, 243, 244)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(243, 243, 244)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(243, 243, 244)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M18 6H16V8H18V6Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M13 3V11H21V3H13ZM20 10H14V4H20V10Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M8 16H6V18H8V16Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M3 21H11V13H3V21ZM4 14H10V20H4V14Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M18 16H16V18H18V16Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M5 9H3V11H5V9Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M11 3H9V5H11V3Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M8 6H6V8H8V6Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M5 3H3V5H5V3Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M11 9H9V11H11V9Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M15 13H13V15H15V13Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M21 13H19V15H21V13Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M15 19H13V21H15V19Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Billets
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-1"
                          aria-expanded="false"
                          aria-label="Menu Billets"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily:
                              "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Offres"
                          href="/app/offre"
                          aria-current="true"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(141, 232, 254)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(141, 232, 254)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(141, 232, 254)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M20 2.99995H19.13V9.86376C19.1298 9.92559 19.109 9.98559 19.071 10.0344C19.033 10.0832 18.9799 10.1181 18.92 10.1335C18.8601 10.1551 18.7948 10.157 18.7337 10.1391C18.6725 10.1211 18.6187 10.0842 18.58 10.0336L16.93 7.90552L16.72 7.80561H16.47L16.37 7.85557L14.63 9.99364C14.5903 10.043 14.5365 10.0791 14.4757 10.0969C14.4149 10.1148 14.3501 10.1136 14.29 10.0935C14.2301 10.0781 14.177 10.0432 14.139 9.99443C14.101 9.94563 14.0802 9.88562 14.08 9.82379V3.16979L13.3 3.67934C12.7551 4.04506 12.3086 4.53916 12 5.11804C11.6544 4.46934 11.1364 3.92841 10.503 3.55473C9.86969 3.18105 9.14547 2.98909 8.41 2.99995H4C3.4798 2.99971 2.97998 3.20199 2.60658 3.56386C2.23319 3.92572 2.01561 4.4187 2 4.9382L2 16.9873C2.01815 17.5051 2.23685 17.9955 2.60997 18.3553C2.98309 18.715 3.48148 18.9159 4 18.9156H7.6C8.45713 18.9091 9.29534 19.1673 10 19.6549L10.64 20.1045L11.26 20.704C11.353 20.7976 11.4636 20.872 11.5854 20.9227C11.7073 20.9734 11.838 20.9995 11.97 20.9995C12.102 20.9995 12.2327 20.9734 12.3546 20.9227C12.4764 20.872 12.587 20.7976 12.68 20.704L13.27 20.1345L13.94 19.6549C14.6455 19.1492 15.4917 18.8767 16.36 18.8756H20C20.5119 18.8764 21.0046 18.681 21.3767 18.3297C21.7488 17.9785 21.9718 17.498 22 16.9873V4.99815C22 4.46819 21.7893 3.95994 21.4142 3.58521C21.0391 3.21047 20.5304 2.99995 20 2.99995ZM6.22 14.1199C6.12343 14.2593 5.98774 14.3671 5.83 14.4296C5.67031 14.4885 5.49821 14.5057 5.33 14.4796C5.16278 14.4428 5.00783 14.3636 4.88 14.2498C4.75317 14.1341 4.66869 13.9794 4.64 13.8102C4.5851 13.655 4.5851 13.4858 4.64 13.3306C4.72046 13.1818 4.84666 13.0627 5 12.9909C5.14667 12.8986 5.31667 12.8501 5.49 12.8511C5.719 12.8529 5.93947 12.9381 6.11 13.0908C6.26862 13.2503 6.35837 13.4655 6.36 13.6903C6.35566 13.844 6.30705 13.9931 6.22 14.1199ZM9.54 14.2098C9.39133 14.3634 9.19281 14.459 8.98 14.4796H8.11C7.99128 14.5044 7.86872 14.5044 7.75 14.4796C7.63529 14.4418 7.52972 14.3806 7.44 14.2998C7.34092 14.2174 7.26509 14.1107 7.22 13.99C7.16708 13.8828 7.13955 13.7649 7.13955 13.6453C7.13955 13.5258 7.16708 13.4079 7.22 13.3007C7.26509 13.18 7.34092 13.0733 7.44 12.9909C7.52972 12.9101 7.63529 12.8489 7.75 12.8111C7.86872 12.7863 7.99128 12.7863 8.11 12.8111H9C9.21281 12.8317 9.41133 12.9273 9.56 13.0809C9.70054 13.2353 9.77841 13.4366 9.77841 13.6453C9.77841 13.8541 9.70054 14.0554 9.56 14.2098H9.54ZM9.54 10.8728C9.39646 11.0222 9.20572 11.1175 9 11.1426H5.5C5.2867 11.1238 5.0876 11.0278 4.94 10.8728C4.79278 10.7218 4.71041 10.5192 4.71041 10.3084C4.71041 10.0975 4.79278 9.89496 4.94 9.74387C5.0876 9.58887 5.2867 9.49296 5.5 9.47411H9C9.21281 9.49471 9.41133 9.59034 9.56 9.74387C9.70054 9.89834 9.77841 10.0996 9.77841 10.3084C9.77841 10.5171 9.70054 10.7184 9.56 10.8728H9.54ZM9.54 7.52587C9.39646 7.67522 9.20572 7.7705 9 7.79562H5.5C5.2867 7.77677 5.0876 7.68086 4.94 7.52587C4.80234 7.38257 4.72072 7.19467 4.71 6.99634C4.70964 6.89256 4.72976 6.78972 4.76923 6.69371C4.8087 6.5977 4.86673 6.51042 4.94 6.43685C5.08659 6.27891 5.28558 6.17951 5.5 6.1571H9C9.21391 6.18124 9.41233 6.28036 9.56 6.43685C9.69439 6.59178 9.76575 6.79141 9.76 6.99634C9.74872 7.19263 9.67116 7.3793 9.54 7.52587ZM19.16 14.2098C19.0098 14.3613 18.8121 14.4565 18.6 14.4796H15.11C14.9002 14.4584 14.7051 14.3627 14.56 14.2098C14.4128 14.0587 14.3304 13.8562 14.3304 13.6453C14.3304 13.4345 14.4128 13.2319 14.56 13.0809C14.7051 12.928 14.9002 12.8323 15.11 12.8111H18.6C18.8121 12.8342 19.0098 12.9294 19.16 13.0809C19.3005 13.2353 19.3784 13.4366 19.3784 13.6453C19.3784 13.8541 19.3005 14.0554 19.16 14.2098Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                WebkitBoxPack: "center",
                                justifyContent: "center",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Offres
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-2"
                          aria-expanded="false"
                          aria-label="Menu Offres"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily:
                              "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                    <li style={{ boxSizing: "border-box" }}>
                      <div
                        style={{
                          boxSizing: "border-box",
                          height: "100%",
                          position: "relative",
                        }}
                      >
                        <a
                          aria-label="Compte"
                          href="/app/account"
                          style={{
                            boxSizing: "border-box",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            margin: "0px",
                            fontSize: "13px",
                            lineHeight: "18px",
                            fontWeight: 700,
                            cursor: "pointer",
                            position: "relative",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            display: "inline-flex",
                            boxShadow: "none",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            color: "rgb(243, 243, 244)",
                            padding: "0px",
                            height: "100%",
                            width: "100%",
                            textTransform: "none",
                            whiteSpace: "pre",
                            textDecoration: "none solid rgb(243, 243, 244)",
                          }}
                        >
                          <div
                            style={{
                              boxSizing: "border-box",
                              WebkitBoxAlign: "center",
                              alignItems: "center",
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <svg
                              aria-hidden="true"
                              viewBox="0 0 24 24"
                              xmlns="http://www.w3.org/2000/svg"
                              style={{
                                boxSizing: "border-box",
                                height: "24px",
                                width: "1.5rem",
                                fill: "rgb(243, 243, 244)",
                                flexShrink: 0,
                                margin: "8px 0px 4px",
                              }}
                            >
                              <path
                                d="M14.2507 10.0988C14.9317 9.65003 15.4628 9.00399 15.7743 8.24522C16.0859 7.48646 16.1634 6.65033 15.9968 5.84629C15.8476 5.03646 15.4591 4.29126 14.8826 3.70878C14.3061 3.12629 13.5686 2.73381 12.7671 2.58299C11.9711 2.41824 11.1444 2.49999 10.3952 2.81754C9.86342 3.0379 9.38334 3.36855 8.98599 3.78813C8.58863 4.2077 8.28284 4.70685 8.08837 5.25332C7.89391 5.79978 7.81511 6.3814 7.85706 6.96056C7.89901 7.53973 8.06078 8.10355 8.33191 8.61559C8.60304 9.12763 8.9775 9.57648 9.43109 9.93313C9.88467 10.2898 10.4073 10.5463 10.9651 10.6861C11.523 10.8259 12.1036 10.8458 12.6696 10.7447C13.2356 10.6435 13.7742 10.4235 14.2507 10.0988ZM13.6956 4.05147C14.2053 4.39619 14.6022 4.88597 14.8361 5.45877C15.1178 6.15045 15.1443 6.92136 14.9107 7.63109C14.6771 8.34082 14.1989 8.94216 13.5633 9.32559C12.9277 9.70903 12.177 9.84904 11.4478 9.72014C10.7186 9.59123 10.0594 9.20198 9.59045 8.62329C9.12146 8.04459 8.87378 7.31494 8.89254 6.56722C8.9113 5.81951 9.19524 5.10347 9.69264 4.54953C10.1901 3.99558 10.8678 3.64057 11.6026 3.54915C12.3373 3.45774 13.0801 3.636 13.6956 4.05147Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                              <path
                                d="M7.39753 15.1161C8.30094 14.1869 9.45816 13.551 10.7212 13.2899C11.9842 13.0287 13.2956 13.1542 14.4877 13.6502C15.6798 14.1462 16.6983 14.9902 17.413 16.0743C18.1278 17.1583 18.5062 18.4332 18.4999 19.7357V20.9901C18.4973 21.1245 18.4433 21.2527 18.3493 21.3477C18.2552 21.4428 18.1283 21.4974 17.9953 21.5C17.8622 21.4974 17.7354 21.4428 17.6413 21.3477C17.5472 21.2527 17.4932 21.1245 17.4906 20.9901V19.7357C17.4906 18.2644 16.9121 16.8534 15.8824 15.813C14.8528 14.7726 13.4562 14.1881 12 14.1881C10.5438 14.1881 9.14721 14.7726 8.11751 15.813C7.08782 16.8534 6.50934 18.2644 6.50934 19.7357V20.9901C6.50676 21.1245 6.45276 21.2527 6.35867 21.3477C6.26459 21.4428 6.13772 21.4974 6.00469 21.5C5.9385 21.5008 5.87288 21.4876 5.81204 21.4612C5.7512 21.4349 5.69649 21.396 5.65143 21.347C5.60295 21.3015 5.56443 21.2462 5.53836 21.1847C5.51228 21.1233 5.49923 21.0569 5.50004 20.9901V19.7357C5.5014 18.0026 6.18392 16.341 7.39753 15.1161Z"
                                style={{ boxSizing: "border-box" }}
                              ></path>
                            </svg>
                            <span
                              style={{
                                boxSizing: "border-box",
                                display: "flex",
                                height: "100%",
                                position: "relative",
                              }}
                            >
                              <span
                                style={{
                                  boxSizing: "border-box",
                                  margin: "0px",
                                  maxWidth: "96px",
                                  fontSize: "11px",
                                  lineHeight: "14px",
                                  fontWeight: 700,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                Compte
                              </span>
                            </span>
                          </div>
                        </a>
                        <button
                          tabIndex={0}
                          type="button"
                          aria-controls="navBar-panelContent-3"
                          aria-expanded="false"
                          aria-label="Menu Compte"
                          style={{
                            boxSizing: "border-box",
                            appearance: "button",
                            textTransform: "none",
                            overflow: "hidden",
                            fontFamily:
                              "Avenir",
                            fontSize: "24px",
                            lineHeight: "27.6px",
                            margin: "-1px",
                            border: "0px none rgb(243, 243, 244)",
                            clip: "rect(0px, 0px, 0px, 0px)",
                            height: "1px",
                            padding: "0px",
                            position: "absolute",
                            whiteSpace: "nowrap",
                            width: "1px",
                            display: "flex",
                            WebkitBoxAlign: "center",
                            alignItems: "center",
                            WebkitBoxPack: "center",
                            justifyContent: "center",
                            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            outline: "rgb(243, 243, 244) none 0px",
                            cursor: "pointer",
                            userSelect: "none",
                            verticalAlign: "middle",
                            textDecoration: "none solid rgb(243, 243, 244)",
                            textAlign: "center",
                            flex: "0 0 auto",
                            borderRadius: "50%",
                            color: "rgb(243, 243, 244)",
                            transition:
                              "background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1) 0s",
                            fill: "rgb(141, 232, 254)",
                            right: "0px",
                            top: "50%",
                            transform: "none",
                          }}
                        >
                          <svg
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            style={{
                              boxSizing: "border-box",
                              height: "24px",
                              width: "1.5rem",
                            }}
                          >
                            <path
                              d="M17.3341 8.79362C16.9383 8.36568 16.2617 8.36568 15.8659 8.79362L12 12.973L8.1341 8.79362C7.73825 8.36568 7.06175 8.36568 6.6659 8.79362L6.62811 8.83447C6.27358 9.21775 6.27358 9.80928 6.62811 10.1926L11.2659 15.2064C11.6617 15.6343 12.3383 15.6343 12.7341 15.2064L17.3719 10.1926C17.7264 9.80928 17.7264 9.21775 17.3719 8.83447L17.3341 8.79362Z"
                              style={{ boxSizing: "border-box" }}
                            ></path>
                          </svg>
                        </button>
                      </div>
                    </li>
                  </ul>
                </nav>
                <div
                  style={{
                    boxSizing: "border-box",
                    WebkitBoxAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    WebkitBoxPack: "end",
                    justifyContent: "flex-end",
                  }}
                ></div>
              </div>
            </div>
            <div
              style={{
                boxSizing: "border-box",
                backgroundColor: "rgb(141, 232, 254)",
                borderTopLeftRadius: "48px",
                borderTopRightRadius: "48px",
                bottom: "0px",
                content: '""',
                height: "2px",
                position: "absolute",
                width: "100%",
                left: "0px",
                opacity: 0,
                pointerEvents: "none",
              }}
            ></div>
          </div>
          <div
            aria-hidden="true"
            style={{
              opacity: 0,
              boxSizing: "border-box",
              position: "fixed",
              display: "flex",
              WebkitBoxAlign: "center",
              alignItems: "center",
              WebkitBoxPack: "center",
              justifyContent: "center",
              inset: "0px",
              WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
              backgroundColor: "rgba(70, 77, 94, 0.7)",
              backdropFilter: "blur(2px)",
              zIndex: 1200,
            }}
          ></div>
        </div>
      </header>
    </div>
  );
};
